import { useEffect, useState } from 'react'

const listeners = new Set()
let deferredPrompt = null

function notify() {
  listeners.forEach((listener) => listener(deferredPrompt))
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    deferredPrompt = event
    notify()
  })
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null
    notify()
  })
}

export function isStandaloneApp() {
  if (typeof window === 'undefined') return false
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
}

export function isIosDevice() {
  if (typeof window === 'undefined') return false
  const ua = window.navigator.userAgent || ''
  return /iphone|ipad|ipod/i.test(ua)
    || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
}

export function subscribeInstallPrompt(listener) {
  listeners.add(listener)
  listener(deferredPrompt)
  return () => listeners.delete(listener)
}

export async function promptInstall() {
  if (!deferredPrompt) return false
  deferredPrompt.prompt()
  const choice = await deferredPrompt.userChoice
  deferredPrompt = null
  notify()
  return choice?.outcome === 'accepted'
}

export function usePwaInstall() {
  const [promptEvent, setPromptEvent] = useState(deferredPrompt)
  const [standalone, setStandalone] = useState(false)
  const [ios, setIos] = useState(false)

  useEffect(() => {
    setStandalone(isStandaloneApp())
    setIos(isIosDevice())
    return subscribeInstallPrompt(setPromptEvent)
  }, [])

  return {
    canInstall: Boolean(promptEvent) && !standalone,
    showIosHint: ios && !standalone,
    standalone,
    promptInstall,
  }
}
